export const MedicalFieldsDTO = {
  ANESTHESIOLOGY: 'anesthesiology',
  CARDIAC_SURGERY_CARDIOTHORACIC_SURGERY: 'cardiac_surgery_cardiothoracic_surgery',
  DERMATOLOGY: 'dermatology',
  DIABETOLOGY: 'diabetology',
  EMERGENCY: 'emergency',
  GENERAL_SURGERY: 'general_surgery',
  GERIATRICS: 'geriatrics',
  GYNECOLOGY: 'gynecology',
  IMMUNOLOGY: 'immunology',
  INFECTIOLOGY: 'infectiology',
  INTENSIVE_CARE_MEDICINE: 'intensive_care_medicine',
  INTERNAL_MEDICINE: 'internal_medicine',
  INTERNAL_MEDICINE_AND_ANGIOLOGY: 'internal_medicine_and_angiology',
  INTERNAL_MEDICINE_AND_CARDIOLOGY: 'internal_medicine_and_cardiology',
  INTERNAL_MEDICINE_AND_ENDOCRINOLOGY_AND_DIABETOLOGY:
    'internal_medicine_and_endocrinology_and_diabetology',
  INTERNAL_MEDICINE_AND_GASTROENTEROLOGY: 'internal_medicine_and_gastroenterology',
  INTERNAL_MEDICINE_AND_HEMATOLOGY_AND_ONCOLOGY: 'internal_medicine_and_hematology_and_oncology',
  INTERNAL_MEDICINE_AND_NEPHROLOGY: 'internal_medicine_and_nephrology',
  INTERNAL_MEDICINE_AND_PULMONOLOGY: 'internal_medicine_and_pulmonology',
  INTERNAL_MEDICINE_AND_RHEUMATOLOGY: 'internal_medicine_and_rheumatology',
  MICROBIOLOGY_VIROLOGY_AND_INFECTION_EPIDEMIOLOGY:
    'microbiology_virology_and_infection_epidemiology',
  NEONATOLOGY: 'neonatology',
  NEUROLOGY: 'neurology',
  NEUROPEDIATRICS: 'neuropediatrics',
  NEURORADIOLOGY: 'neuroradiology',
  NEUROSURGERY: 'neurosurgery',
  NUTRITIONAL_MEDICINE: 'nutritional_medicine',
  OBSTETRICS: 'obstetrics',
  OCCUPATIONAL_MEDICINE: 'occupational_medicine',
  ONCOLOGY: 'oncology',
  OPHTHALMOLOGY: 'ophthalmology',
  ORAL_AND_MAXILLOFACIAL_SURGERY: 'oral_and_maxillofacial_surgery',
  ORTHOPEDICS_AND_TRAUMA_SURGERY: 'orthopedics_and_trauma_surgery',
  PALLIATIVE_MEDICINE: 'palliative_medicine',
  PATHOLOGY: 'pathology',
  PEDIATRIC_CARDIOLOGY: 'pediatric_cardiology',
  PEDIATRIC_ENDOCRINOLOGY: 'pediatric_endocrinology',
  PEDIATRIC_GASTROENTEROLOGY: 'pediatric_gastroenterology',
  PEDIATRIC_HEMATOLOGY_AND_PEDIATRIC_ONCOLOGY: 'pediatric_hematology_and_pediatric_oncology',
  PEDIATRIC_PULMONOLOGY: 'pediatric_pulmonology',
  PEDIATRICS: 'pediatrics',
  PEDIATRIC_SURGERY: 'pediatric_surgery',
  PHARMACOLOGY_AND_TOXICOLOGY: 'pharmacology_and_toxicology',
  PSYCHIATRY_AND_PSYCHOTHERAPY: 'psychiatry_and_psychotherapy',
  RADIATION_THERAPY: 'radiation_therapy',
  RADIOLOGY: 'radiology',
  SPECIALIZED_PAIN_THERAPY: 'specialized_pain_therapy',
  THORACIC_SURGERY: 'thoracic_surgery',
  UROLOGY: 'urology',
  VASCULAR_SURGERY: 'vascular_surgery',
  VISCERAL_SURGERY: 'visceral_surgery'
} as const

export type MedicalFieldsDTO = (typeof MedicalFieldsDTO)[keyof typeof MedicalFieldsDTO]
